<template>
  <div class="main">
    <div class="nav">
      <Nav :title="'面访签到'" :arrow="false"></Nav>
    </div>
    <!-- 内容 -->
    <div class="content">
      <!-- 标签 -->
      <div>
        <van-tabs v-model="active2" @click="onClick" color="#FBAC01">
          <div><van-search v-model="uservalue" @input="userinput" placeholder="请输入搜索关键词" /></div>
          <van-tab title="客户" @scroll="handleScroll">
            <kuhuList :clientlist="clientlist" :name="'客户'"></kuhuList>
          </van-tab>
          <van-tab title="商机">
            <!-- <div class="kuhuList scroll-container"> -->
            <kuhuList class="kuhuList" :clientlist="clientlist" :name="'商机'"></kuhuList>
            <!-- </div> -->
          </van-tab>
          <van-tab title="渠道">
            <div class="scroll-container" @scroll="handleScroll">
              <kuhuList class="kuhuList" :clientlist="clientlist" :name="'渠道'"></kuhuList>

            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
    <div class="footer">
      <fooalt :active="0"></fooalt>
    </div>
    <!-- loading -->
    <van-overlay :show="show">
      <div style="width: 100%;height: 100%;display: grid;place-items: center;">
        <van-loading type="spinner" color="#1989fa" />
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Nav from './component/nav.vue';
import kuhuList from './component/kuhuList.vue';
import fooalt from './component/fooalt.vue';
import { qiweiAPI } from '../../../api/qiwei.js';
import { Notify } from 'vant';
export default {
  data() {
    return {
      clientlist: [],
      chuchailist: [],
      clientvalue: '客户',
      show: false,
      uservalue: '',
      totalitems: 0,
      page: 1,
      flage: true,
      active2: 0,

    }
  },
  beforeCreate() {
    console.log(this.code);
  },
  mounted() {
    // console.log(this.$t);  
    console.log(this.$route.query)
    if (this.$t.active2) {
      this.active2 = this.$t.active2
    }
    const urlParams = new URLSearchParams(window.location.search);
    const urlhash = new URLSearchParams(window.location.hash.split("?")[1]);
    const code = urlParams.get("code") || urlhash.get("code");
    if (this.$t.active2 == 0) {
      this.KeLeShouCustomersData({
        qw_user_id: this.$t.qiwei_yuangong_num,
        keywords: this.uservalue,
        page: this.page,
        limit: 5,
      })
    } else if (this.$t.active2 == 1) {
      this.KeLeShouOpportunityData({
        qw_user_id: this.$t.qiwei_yuangong_num,
        keywords: this.uservalue,
        page: this.page,
        limit: 5,
      })
    } else if (this.$t.active2 == 2) {
      this.KeLeShouChannelData({
        qw_user_id: this.$t.qiwei_yuangong_num,
        keywords: this.uservalue,
        page: this.page,
        limit: 5,
      })
    }

    if (this.$t.codefalse == 2) {
      this.KeLeShouCustomersData({
        qw_user_id: this.$t.qiwei_yuangong_num,
        keywords: this.uservalue,
        page: this.page,
        limit: 5,
      })
    } else {
      this.getuserinfo({ code })
    }


  },
  methods: {

    // 客户大客户一级标签选择
    onClick(index, name, title) {
      console.log(index, name, title);
      this.active2 = index
      this.$t.active2 = index;
      this.uservalue = ''
      this.page = 1
      this.clientlist = []
      this.show = true
      this.flage = true
      this.clientvalue = name
      if (index == 0) {
        var data = {
          qw_user_id: this.$t.qiwei_yuangong_num,
          keywords: this.uservalue,
          page: this.page,
          limit: 5,
        }
        this.KeLeShouCustomersData(data)
      }
      if (index == 1) {
        // 商机
        this.KeLeShouOpportunityData({
          qw_user_id: this.$t.qiwei_yuangong_num,
          keywords: this.uservalue,
          page: this.page,
          limit: 5,
        })
      }
      if (index == 2) {
        this.KeLeShouChannelData({
          qw_user_id: this.$t.qiwei_yuangong_num,
          keywords: this.uservalue,
          page: this.page,
          limit: 5,
        })
      }
    },

    // crm客户列表
    KeLeShouCustomersData(params) {
      this.show = true
      this.$axios
        .get(qiweiAPI.KeLeShouCustomersData, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 1) {
            this.show = false
            this.clientlist = res.data.data
          } else {
            this.clientlist = [];
            this.show = false
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // crm客户商机列表
    KeLeShouOpportunityData(params) {
      this.$axios
        .get(qiweiAPI.KeLeShouOpportunityData, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 1) {
            this.show = false
            this.clientlist = res.data.data

          } else {
            this.clientlist = [];
            this.show = false
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 搜索
    userinput() {
      this.page = 1
      this.flage = true
      if (this.clientvalue == '客户') {
        this.KeLeShouCustomersData({
          qw_user_id: this.$t.qiwei_yuangong_num,
          keywords: this.uservalue,
          page: this.page,
          limit: 5,
        })
      }
      if (this.clientvalue == '商机') {
        this.KeLeShouOpportunityData({
          qw_user_id: this.$t.qiwei_yuangong_num,
          keywords: this.uservalue,
          page: this.page,
          limit: 5,
        })
      }
      if (this.clientvalue == '渠道') {
        this.KeLeShouChannelData({
          qw_user_id: this.$t.qiwei_yuangong_num,
          keywords: this.uservalue,
          page: this.page,
          limit: 5,
        })
      }

    },
    // 页面滚动
    handleScroll() {
      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // console.log(scrollTop, scrollHeight, clientHeight);
      // 检查是否已经滚动到底部或右边
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        if (this.flage == true) {
          this.flage = false
          this.page = this.page + 1
          if (this.clientvalue == '渠道') {
            this.show = true
            var params = {
              qw_user_id: this.$t.qiwei_yuangong_num,
              keywords: this.uservalue,
              page: this.page,
              limit: 5,
            }
            this.$axios
              .get(qiweiAPI.KeLeShouChannelData, {
                params,
                headers: this.$t.headers,
              })
              .then((res) => {
                console.log(res)
                this.show = false
                if (res.data.code == 1) {
                  // 如果有数据，则继续滚动加载
                  this.flage = true
                  this.clientlist = this.clientlist.concat(res.data.data)
                } else {
                  Notify({ type: 'warning', message: '没有数据了' });
                }
              })
          } else if (this.clientvalue == '客户') {
            this.show = true
            var params = {
              qw_user_id: this.$t.qiwei_yuangong_num,
              keywords: this.uservalue,
              page: this.page,
              limit: 5,
            }
            this.$axios
              .get(qiweiAPI.KeLeShouCustomersData, {
                params,
                headers: this.$t.headers,
              })
              .then((res) => {
                console.log(res)
                this.show = false
                if (res.data.code == 1) {
                  // 如果有数据，则继续滚动加载
                  this.flage = true
                  this.clientlist = this.clientlist.concat(res.data.data)
                } else {
                  Notify({ type: 'warning', message: '没有数据了' });
                }
              })
          }else if (this.clientvalue == '商机') {
            this.show = true
            var params = {
              qw_user_id: this.$t.qiwei_yuangong_num,
              keywords: this.uservalue,
              page: this.page,
              limit: 5,
            }
            this.$axios
              .get(qiweiAPI.KeLeShouOpportunityData, {
                params,
                headers: this.$t.headers,
              })
              .then((res) => {
                console.log(res)
                this.show = false
                if (res.data.code == 1) {
                  // 如果有数据，则继续滚动加载
                  this.flage = true
                  this.clientlist = this.clientlist.concat(res.data.data)
                } else {
                  Notify({ type: 'warning', message: '没有数据了' });
                }
              })
          }
        }
      }
    },
    // crm客户渠道
    KeLeShouChannelData(params) {
      this.$axios
        .get(qiweiAPI.KeLeShouChannelData, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)
          if (res.data.code == 1) {
            this.show = false
            this.clientlist = res.data.data

          } else {
            this.clientlist = [];
            this.show = false
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    // 获取客户员工号
    getuserinfo(params) {
      this.show = true
      this.$axios
        .get(qiweiAPI.KeLeShougetuserinfo, {
          params,
          headers: this.$t.headers,
        })
        .then((res) => {
          console.log(res)

          if (res.data.code == 1) {
            this.usernum = res.data.data
            this.$t.qiwei_yuangong_num = res.data.data
            this.$t.codefalse = 2
            this.KeLeShouCustomersData({
              // qw_user_id: 'BJR1106',
              qw_user_id: this.$t.qiwei_yuangong_num,
            })
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },

  components: {
    Nav,
    kuhuList,
    fooalt
  }

}
</script>

<style>
.main {
  width: 100%;
  height: 100%;
  /* 设置一个固定高度 */
  overflow: hidden
}

.nav {
  width: 100%;
}

.kuhuList {
  margin-top: 15px;
}

.content {
  padding-bottom: 60px;

}

.scroll-container {
  height: 700px;
  /* 设置一个固定高度 */
  overflow-y: auto;
  /* 开启垂直滚动 */
}
</style>


// WEBPACK FOOTER //
// src/pages/qiwei/keleshou/mianqian.vue